import { gql } from '@apollo/client';

export const AUDITOR_DASHBOARD_AUDIT_JOBS = gql`
  query auditorDashboardAuditJobs(
    $limit: Int
    $offset: Int
  ) {
    auditorDashboardAuditJobs(
      limit: $limit
      offset: $offset
    ){
      jobId
      reportNumber
      status
      auditEndAt
      auditStartAt
      serviceNames
      factoryName
      programName
      reportReviewClosedNotesCount
      reportReviewAllNotesCount
      auditorNames
    }
    auditorDashboardAuditJobsPageInfo{
      totalCount
    }
  }

`;

export const AUDITOR_DASHBOARD_REVIEW_JOBS = gql`
  query auditorDashboardReviewJobs(
    $limit: Int
    $offset: Int
  ) {
    auditorDashboardReviewJobs (
      limit: $limit
      offset: $offset
    ) {
      jobId
      reportNumber
      status
      auditEndAt
      auditStartAt
      serviceNames
      factoryName
      programName
      reportReviewClosedNotesCount
      reportReviewAllNotesCount
      auditorNames
      actionRequired
    }
    auditorDashboardReviewJobsPageInfo {
      totalCount
    }
  }
`;

export const REPORT_REVIEWER_DASHBOARD_JOBS = gql`
  query reportReviewerDashboardJobs (
    $limit: Int
    $offset: Int
  ) {
    reportReviewerDashboardJobs(
      limit: $limit
      offset: $offset
    ) {
      jobId
      reportNumber
      status
      auditEndAt
      auditStartAt
      serviceNames
      factoryName
      programName
      reportReviewClosedNotesCount
      reportReviewAllNotesCount
      auditorNames
      actionRequired
      reviewerId
    }
    reportReviewerDashboardJobsPageInfo {
      totalCount
    }
  }
`;

export const CAP_MANAGER_DASHBOARD_JOBS = gql`
  query {
    capManagerDashboardJobs {
      jobId
      reportNumber
      status
      auditEndAt
      auditStartAt
      serviceNames
      factoryName
      programName
      reportReviewClosedNotesCount
      reportReviewAllNotesCount
      auditorNames
      actionRequired
      totalFindingsWithoutNotRequiredCount
      openFindingsCount
      findings {
        info {
          name
        }
        approvedActionCount
        rejectedActionCount
        pendingActionCount
        responsiblePerson
      }
    }
  }
`;

export const FACTORY_USER_DASHBOARD_JOB = gql`
  query {
    factoryUserDashboardJob {
      ratingGrades {
        name
        color
        max
        min
      }
      score
      jobId
      reportNumber
      findings {
        id
        info {
          name
        }
        rejectedActionCount
        approvedActionCount
        pendingActionCount
      }
    }
  }
`;

export const JOBS_SUMMARY = gql`
  query($startDate: DateTime, $endDate: DateTime, $countryIds: [Int!]) {
    jobsSummaryDashboard(
      startDate: $startDate
      endDate: $endDate
      countryIds: $countryIds
    ) {
      openJobsCount
      staffUtilizationTotal
      staffUtilizationCount
      allocations
      volumesByCountryOrRegion {
        name
        count
        countryId
      }
      lateReports {
        job {
          id
          reportNumber
        }
        days
      }
    }
  }
`;

export const EXTERNAL_USERS_ACTIVE_SAQ_JOBS = gql`
  query saqJobsDashboard (
    $limit: Int
    $offset: Int
  ) {
    saqJobsDashboard (
      limit : $limit
      offset: $offset
    ) {
      jobId
      reportNumber
      reportReviewClosedNotesCount
      score
      status
      serviceNames
      totalFindingsWithoutNotRequiredCount
      auditStartAt
      auditEndAt
      actionRequired
      auditorNames
      findings {
        status
        statusDate
        statusNotes
      }
      factoryName
    }
    saqJobsDashboardPageInfo {
      totalCount
    }
  }
`;
